var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnRed48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2393 19.6367C40.7178 19.6367 42.7275 21.59 42.7275 24C42.7275 26.41 40.7178 28.3633 38.2393 28.3633C35.7608 28.3632 33.752 26.4099 33.752 24C33.752 21.5901 35.7608 19.6368 38.2393 19.6367ZM38.2393 20.3643C36.1739 20.3644 34.5 21.9918 34.5 24C34.5 26.0082 36.1739 27.6356 38.2393 27.6357C40.3047 27.6357 41.9785 26.0083 41.9785 24C41.9785 21.9917 40.3047 20.3643 38.2393 20.3643Z",
    fill: "#A00000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41504 20.7275C11.2738 20.7278 12.7803 22.1927 12.7803 24C12.7803 25.8073 11.2738 27.2722 9.41504 27.2725C7.55613 27.2725 6.04883 25.8075 6.04883 24C6.04883 22.1925 7.55613 20.7275 9.41504 20.7275ZM9.41504 21.8184C8.17577 21.8184 7.1709 22.795 7.1709 24C7.1709 25.205 8.17577 26.1816 9.41504 26.1816C10.6541 26.1814 11.6582 25.2049 11.6582 24C11.6582 22.7951 10.6541 21.8186 9.41504 21.8184Z",
    fill: "#A00000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.4238C13.5 20.8304 14.2499 20.6159 14.5771 21.0576L14.6367 21.1553L16.5 24.8818V20.8301H17.5V26.5762C17.4999 27.2092 16.6464 27.4109 16.3633 26.8447L14.5 23.1182V27.1797H13.5V21.4238Z",
    fill: "#A00000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8291 18C44.2371 18 47 20.6863 47 24C47 27.3137 44.2371 30 40.8291 30H7.1709C3.7629 30 1 27.3137 1 24C1 20.6863 3.7629 18 7.1709 18H40.8291ZM7.1709 19.0908C4.38253 19.0908 2.12207 21.2888 2.12207 24C2.12207 26.7112 4.38253 28.9092 7.1709 28.9092H40.8291C43.6175 28.9092 45.8779 26.7112 45.8779 24C45.8779 21.2888 43.6175 19.0908 40.8291 19.0908H7.1709Z",
    fill: "#A00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnRed48);
export default __webpack_public_path__ + "static/media/on_red48.c347a88831d5ccb92a666a72632764f5.svg";
export { ForwardRef as ReactComponent };